module.exports = __webpack_public_path__ + "static/media/92.a4d8e9f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/92.jpg
// module id = 1024
// module chunks = 0